module.exports = __webpack_public_path__ + "img/ICONE-THEMATIQUE.e3673b78.svg";